import React from 'react';
import classnames from 'classnames';

import styles from '../../CostCenters.module.scss';

interface Props {
  noUnassignedAccounts?: boolean | undefined;
}

const CostCentersUnassignedAccountsIcon = ({ noUnassignedAccounts }: Props) => (
  <div
    className={classnames(styles.costCentersUnassignedAccountsIconContainer, {
      [styles.noUnassignedAccountsIcon]: noUnassignedAccounts,
    })}
  >
    <div className={styles.unassignedAccountsIcon}>?</div>
  </div>
);

export default CostCentersUnassignedAccountsIcon;
